var cov_108ku9juc = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Progress/index.tsx",
      hash = "861105aacbee509bb2f6db10fced4362e6bba84d",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Progress/index.tsx",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 2
        },
        end: {
          line: 13,
          column: 3
        }
      },
      "1": {
        start: {
          line: 10,
          column: 6
        },
        end: {
          line: 10,
          column: 34
        }
      },
      "2": {
        start: {
          line: 12,
          column: 6
        },
        end: {
          line: 12,
          column: 32
        }
      },
      "3": {
        start: {
          line: 16,
          column: 0
        },
        end: {
          line: 18,
          column: 1
        }
      },
      "4": {
        start: {
          line: 20,
          column: 0
        },
        end: {
          line: 20,
          column: 41
        }
      }
    },
    fnMap: {
      "0": {
        name: "Progress",
        decl: {
          start: {
            line: 7,
            column: 9
          },
          end: {
            line: 7,
            column: 17
          }
        },
        loc: {
          start: {
            line: 7,
            column: 40
          },
          end: {
            line: 14,
            column: 1
          }
        },
        line: 7
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 8,
            column: 2
          },
          end: {
            line: 13,
            column: 3
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 9,
            column: 4
          },
          end: {
            line: 10,
            column: 34
          }
        }, {
          start: {
            line: 11,
            column: 4
          },
          end: {
            line: 12,
            column: 32
          }
        }],
        line: 8
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Progress/index.tsx";
import React from 'react';
import Line from './Line';
import Circle from './Circle';

function Progress(props) {
  cov_108ku9juc.f[0]++;
  cov_108ku9juc.s[0]++;

  switch (props.shape) {
    case 'circle':
      cov_108ku9juc.b[0][0]++;
      cov_108ku9juc.s[1]++;
      return (
        /*#__PURE__*/
        React.createElement(Circle, Object.assign({}, props, {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 10,
            columnNumber: 14
          }
        }))
      );

    default:
      cov_108ku9juc.b[0][1]++;
      cov_108ku9juc.s[2]++;
      return (
        /*#__PURE__*/
        React.createElement(Line, Object.assign({}, props, {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 12,
            columnNumber: 14
          }
        }))
      );
  }
}

cov_108ku9juc.s[3]++;
Progress.defaultProps = {
  shape: 'line'
};
cov_108ku9juc.s[4]++;
Progress.displayName = 'ShineoutProgress';
export default Progress;